import { inject, Injectable } from '@angular/core';
import {getBrowserLang, TranslocoService} from '@jsverse/transloco';
import {TranslocoPersistLangService} from '@jsverse/transloco-persist-lang';
import { APP_CONFIG } from '../utils/app.config';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly appConfig = inject(APP_CONFIG);
  private readonly persist = inject(TranslocoPersistLangService);
  private readonly translocoService = inject(TranslocoService);

  initLanguage() {
    if (!this.appConfig.i18n) return;

    const browserLang = getBrowserLang();
    const cachedLang = this.persist.getCachedLang();

    if (cachedLang) {
      this.translocoService.setActiveLang(cachedLang);
      return;
    }

    if (browserLang === 'cs') {
      this.translocoService.setActiveLang('cs');
    } else {
      this.translocoService.setActiveLang('en');
    }
  }
}
